export const articleSize = 6;
export const gallerySize = 6;
export const videoSize = 6;
export const activitySize = 9;
export const newsSize = 8;
